import { AavoBackendError } from "src/errorHandling/aavoBackendError";
import { AavoErrorResponse } from "src/errorHandling/aavoErrorResponse";

export type AnyError = Error | AavoBackendError | string;

export const isAavoBackendError = (
	value: AnyError
): value is AavoBackendError => {
	return (value as AavoBackendError)?.message !== undefined;
};

export const isAavoErrorResponse = (
	value: AnyError
): value is AavoErrorResponse => {
	return isAavoBackendError((value as AavoErrorResponse)?.response?.data);
};
